import { FloraTypography, Flex } from '@grupoboticario/flora-react'

import { titleContainerStyle } from './styles'

const HeadingAccelerator = ({ title }: { title: string }) => {
  return (
    <Flex css={titleContainerStyle}>
      <FloraTypography as="h2" fontSize="subtitle" fontWeight="medium" viewport="desktop">
        {title}
      </FloraTypography>
    </Flex>
  )
}

export default HeadingAccelerator
